import { useState } from 'react';
import { Button, Col, Form, FormGroup, Input, Row, Spinner } from 'reactstrap';
import useAdminAdditionalInfo from './hooks/useAdminAdditionalInfo';
import { Controller } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import { checkOptions } from '../../constants/formConstants';
import OwnerField from './components/AdditionalInfo/OwnerField';
import AdminPage from '../../components/admin/AdminPage';
import LoadingCard from '../../components/LoadingCard';
import GenerateDescriptionAIModal from './components/GenerateDescriptionAIModal';
import { getCurrentPropertyTags } from './adapters/propertyAdapter';

const SectionTitle = ({ icon, title }: { icon: string; title: string }) => (
  <h5 className="text-uppercase text-muted ls-1 mb-3 mt-4 border-bottom pb-2">
    <i className={`${icon} mr-2`}></i>
    {title}
  </h5>
);

export const AdminPropertyAdditionalInfo = () => {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const [isAiModalOpen, setIsAiModalOpen] = useState(false);
  const [isAiProcessing, setIsAiProcessing] = useState(false);
  // Descripción previa a la generada con IA, para poder deshacer.
  const [previousDescription, setPreviousDescription] = useState<string | null>(
    null,
  );
  const {
    isLoading,
    control,
    register,
    setValue,
    watch,
    landTypeIds,
    errors,
    handleSubmit,
    formUpdateData,
    doAction,
    onInvalid,
    catalogs,
    loadingCurrency,
    currentCurrency,
    propersOptions,
    isLoadingPropers,
  } = useAdminAdditionalInfo({ id });

  const safePropertyTypes = Array.isArray(catalogs.propertyTypes)
    ? catalogs.propertyTypes.filter(
      (item) => !!item && typeof item.id !== 'undefined' && item.id !== null,
    )
    : [];

  if (!formUpdateData) {
    return (
      <LoadingCard name={'Actualizar propiedad'} parent_name={'Propiedades'} />
    );
  }

  const selectedType = formUpdateData.type?.id
    ? safePropertyTypes.find((x) => x.id === formUpdateData.type.id)
    : undefined;

  const existingGallery: string[] = Array.isArray(formUpdateData.gallery)
    ? formUpdateData.gallery
    : [];
  const hasEnoughImages = existingGallery.length >= 2;

  const isLand = landTypeIds.current.includes(watch('type_id'));
  const hasPropiKeys = String(watch('has_propi_property_keys')) === 'true';
  const description = watch('description') ?? '';

  return (
    <AdminPage
      name={`Actualizar propiedad #${formUpdateData?.code}`}
      parentName={'Propiedades'}
      header={<h3 className="mb-0">{'Actualizar información adicional'}</h3>}
    >
      <Row>
        <Col lg="10" xl="9">
          <Form role="form" onSubmit={handleSubmit(doAction, onInvalid)}>
            <SectionTitle icon="fa-solid fa-house" title="Datos generales" />
            <Row>
              {/* type */}
              <Col md="6">
                <FormGroup>
                  <label className="form-control-label d-block">
                    Tipo de propiedad
                  </label>
                  {safePropertyTypes.map((item) => (
                    <div
                      key={`type-property-${item.id}`}
                      className="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        {...register('type_id')}
                        className="custom-control-input"
                        type="radio"
                        value={item.id}
                        id={item.id}
                        defaultChecked={selectedType?.id === item.id}
                      />
                      <label className="custom-control-label" htmlFor={item.id}>
                        {item.type}
                      </label>
                    </div>
                  ))}
                  <h5 className="text-danger">{errors.type_id?.message}</h5>
                </FormGroup>
              </Col>
              {/* Currency */}
              <Col md="6">
                <FormGroup>
                  <label className="form-control-label" htmlFor="currency">
                    Moneda
                  </label>
                  {!loadingCurrency && (
                    <Controller
                      name="currency"
                      control={control}
                      defaultValue={currentCurrency.value || ''}
                      render={({ field: { ref } }) => (
                        <Select
                          placeholder="Selecciona una moneda"
                          options={catalogs.currencies}
                          defaultValue={currentCurrency}
                          onChange={(selected: any) => {
                            const { value = '' } = selected;
                            setValue('currency', value);
                          }}
                          ref={ref}
                        />
                      )}
                    />
                  )}
                  <h5 className="text-danger">{errors.currency?.message}</h5>
                </FormGroup>
              </Col>
              {/* property_number: los terrenos no lo llevan */}
              {!isLand && (
                <Col md="6">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="property_number"
                    >
                      Número de casa o apartamento
                    </label>
                    <Controller
                      name="property_number"
                      control={control}
                      defaultValue={''}
                      render={({ field }) => (
                        <Input
                          className={`text-dark ${errors.property_number?.message ? 'is-invalid' : ''
                            }`}
                          {...field}
                          id="property_number"
                        />
                      )}
                    />
                    <h5 className="text-danger">
                      {errors.property_number?.message}
                    </h5>
                  </FormGroup>
                </Col>
              )}
              {/* description */}
              <Col md="12">
                <FormGroup>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label
                      className="form-control-label mb-0"
                      htmlFor="description"
                    >
                      Descripción
                    </label>

                    {/* BOTON DE SEARCHSMARTLY OCULTO */}

                    {/* <div className="d-flex align-items-center">
                      {!hasEnoughImages && (
                        <small className="text-muted mr-2 font-italic">
                          <i className="fa fa-info-circle text-info mr-1" />
                          Es necesario subir al menos 2 fotos a la galería para
                          generar la descripción con IA
                        </small>
                      )}
                      {previousDescription !== null && (
                        <Button
                          color="secondary"
                          outline
                          size="sm"
                          type="button"
                          className="mr-2"
                          onClick={() => {
                            setValue('description', previousDescription, {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                            setPreviousDescription(null);
                          }}
                        >
                          <i className="fa-solid fa-rotate-left mr-1" />
                          Deshacer
                        </Button>
                      )}
                      <Button
                        color="primary"
                        outline
                        size="sm"
                        type="button"
                        className="btn-inner--icon"
                        disabled={!hasEnoughImages || isAiProcessing}
                        title={
                          !hasEnoughImages
                            ? 'Es necesario haber subido al menos 2 fotos a la galería de la propiedad para usar el generador de descripción con IA'
                            : 'Generar descripción con IA'
                        }
                        onClick={() => setIsAiModalOpen(!isAiModalOpen)}
                      >
                        {isAiProcessing ? (
                          <>
                            <Spinner size="sm" className="mr-1" />
                            Generando...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-duotone fa-sparkles mr-1" />
                            Generar con IA
                          </>
                        )}
                      </Button>
                    </div> */}
                  </div>
                  <Controller
                    name="description"
                    control={control}
                    defaultValue={''}
                    render={({ field }) => (
                      <Input
                        type="textarea"
                        rows={8}
                        className={`text-dark ${errors.description?.message ? 'is-invalid' : ''
                          }`}
                        {...field}
                        id="description"
                      />
                    )}
                  />
                  <small className="text-muted d-block text-right">
                    {description.length} caracteres
                  </small>
                  <h5 className="text-danger">{errors.description?.message}</h5>
                </FormGroup>
                <GenerateDescriptionAIModal
                  isOpen={isAiModalOpen}
                  toggle={() => setIsAiModalOpen(!isAiModalOpen)}
                  propertyId={id}
                  existingGallery={existingGallery}
                  onProcessingChange={setIsAiProcessing}
                  onGeneratedDescription={(aiDescription) => {
                    setPreviousDescription(description);
                    setValue('description', aiDescription, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  }}
                />
              </Col>
            </Row>

            <SectionTitle icon="fa-solid fa-key" title="Llaves y acceso" />
            <Row>
              <Col md="12">
                <FormGroup>
                  <label className="form-control-label d-block">
                    Propi tiene las llaves
                  </label>
                  {checkOptions.map((item: any) => (
                    <div
                      key={`div_propi_property_keys-${item.name}`}
                      className="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        {...register('has_propi_property_keys')}
                        className="custom-control-input"
                        type="radio"
                        value={item.value}
                        defaultChecked={
                          item.value ===
                          (formUpdateData?.has_propi_property_keys || false)
                        }
                        id={`has_propi_property_keys-${item.name}`}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={`has_propi_property_keys-${item.name}`}
                      >
                        {item.name}
                      </label>
                    </div>
                  ))}
                </FormGroup>
              </Col>
              {/* solo si Propi NO tiene las llaves */}
              {!hasPropiKeys && (
                <Col md="12">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="location_property_keys"
                    >
                      Instrucciones para obtener las llaves
                    </label>
                    <Controller
                      name="location_property_keys"
                      control={control}
                      defaultValue={''}
                      render={({ field }) => (
                        <Input
                          className={`text-dark ${errors.location_property_keys?.message
                            ? 'is-invalid'
                            : ''
                            }`}
                          placeholder="Ej: Pedir al guardia en la entrada"
                          {...field}
                          id="location_property_keys"
                        />
                      )}
                    />
                    <h5 className="text-danger">
                      {errors.location_property_keys?.message}
                    </h5>
                  </FormGroup>
                </Col>
              )}
            </Row>

            <SectionTitle icon="fa-solid fa-user-tie" title="Asignación" />
            <Row>
              {/* Proper */}
              {!isLoadingPropers && (
                <Col md="6">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="proper_id">
                      Proper asignado
                    </label>
                    <Controller
                      key={'proper_id'}
                      control={control}
                      name="proper_id"
                      render={({ field }) => (
                        <Select
                          key={`proper-`}
                          placeholder={'Selecciona un proper'}
                          options={propersOptions}
                          defaultValue={propersOptions.find(
                            (po) => po.value === formUpdateData?.proper_id,
                          )}
                          onChange={(selected) => {
                            if (selected) {
                              setValue('proper_id', selected.value);
                            }
                          }}
                          ref={field.ref}
                        />
                      )}
                    />
                    <h5 className="text-danger">{errors.proper_id?.message}</h5>
                  </FormGroup>
                </Col>
              )}
              {/* Tags */}
              <Col md="6">
                <FormGroup>
                  <label className="form-control-label" htmlFor="property_tags">
                    Categorización
                  </label>
                  {!!catalogs.tags && (
                    <Controller
                      name="property_tags"
                      control={control}
                      render={() => (
                        <Select
                          key={`property-tags-${catalogs.tags?.length || 0}`}
                          placeholder="Selecciona una o más categorías"
                          isMulti
                          options={catalogs.tags}
                          defaultValue={getCurrentPropertyTags(
                            catalogs.tags || [],
                            formUpdateData?.property_tags || [],
                          )}
                          onChange={(optionSelected) =>
                            setValue(
                              'property_tags',
                              optionSelected.map((tag: any) => tag.value),
                            )
                          }
                        />
                      )}
                    />
                  )}
                  <h5 className="text-danger">
                    {errors.property_tags?.message}
                  </h5>
                </FormGroup>
              </Col>
              {/* Landlord */}
              <Col md="12">
                <FormGroup>
                  <label className="form-control-label">Propietario</label>
                  <OwnerField
                    currentName={formUpdateData?.landlord_info?.name}
                    currentEmail={formUpdateData?.landlord_info?.email}
                    onOwnerFound={(landlordId) =>
                      setValue('landlord_id', landlordId)
                    }
                    // undefined se omite del JSON; '' fallaría @IsUUID en el backend
                    onOwnerCleared={() =>
                      setValue('landlord_id', undefined as unknown as string)
                    }
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className="text-right border-top pt-3 mt-4">
              <Button
                type="button"
                color="secondary"
                outline
                className="mr-2"
                onClick={() => navigate(`/properties/admin/${id}`)}
              >
                Cancelar
              </Button>
              <Button color="primary" disabled={isLoading}>
                Actualizar
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </AdminPage>
  );
};
